import { render, staticRenderFns } from "./pr.vue?vue&type=template&id=88a2e42a&"
import script from "./pr.vue?vue&type=script&lang=js&"
export * from "./pr.vue?vue&type=script&lang=js&"
import style0 from "./pr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports